export default class StringTokenizer {
  _string
  _delimiters
  _returnDelim
  _position
  constructor(string, delimiters, returnDelim) {
    this._string = string
    this._delimiters = delimiters
    this._returnDelim = returnDelim
    this._position = 0
  }

  countTokens() {
    let count = 0
    let inToken = false
    for (let i = this._position, length = this._string.length; i < length; i++) {
      if (this._delimiters.indexOf(this._string.charAt(i)) != -1) {
        if (this._returnDelim) count++
        if (inToken) {
          count++
          inToken = false
        }
      } else {
        inToken = true
      }
    }
    if (inToken) count++
    return count
  }

  hasMoreElements() {
    return this.hasMoreTokens()
  }

  hasMoreTokens() {
    if (!this._delimiters) {
      return false
    }

    const length = this._string.length
    if (this._position < length) {
      if (this._returnDelim) return true

      for (let i = this._position; i < length; i++) {
        if (this._delimiters.indexOf(this._string.charAt(i)) == -1) {
          return true
        }
      }
    }
    return false
  }

  nextElement() {
    return this.nextToken()
  }

  nextToken() {
    if (!this._delimiters) {
      return undefined
    }

    let i = this._position
    const length = this._string.length

    if (i < length) {
      if (this._returnDelim) {
        if (this._delimiters.indexOf(this._string.charAt(this._position)) != -1)
          return this._string.charAt(this._position++)
        for (this._position++; this._position < length; this._position++)
          if (this._delimiters.indexOf(this._string.charAt(this._position)) != -1)
            return this._string.substr(i, this._position - i)
        return this._string.substr(i)
      }

      while (
        i < length &&
        this._delimiters.indexOf(this._string.charAt(this._position)) != -1
      )
        i++
      this._position = i
      if (i < length) {
        for (this._position++; this._position < length; this._position++)
          if (this._delimiters.indexOf(this._string.charAt(this._position)) != -1)
            return this._string.substr(i, this._position - i)
        return this._string.substr(i)
      }
    }

    return undefined
  }

  nextTokenWithDelimiters(delimiters) {
    this._delimiters = delimiters
    return this.nextToken()
  }
}
